import React, { useState } from 'react';

let timer;

function GroupByBtn({ select, setSelect, options }) {
  const [openDownMenu, setOpenDownMenu] = useState(false);

  const enterDownMenu = () => {
    clearTimeout(timer);
    setOpenDownMenu(true);
  };

  const leaveDownMenu = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setOpenDownMenu(false);
    }, 350);
  };

  return (
    <div className="wrapper-group-by">
      <button className="dashboard__block__group-by" onClick={() => setOpenDownMenu(true)}>
        <span>{select}</span>
      </button>
      {openDownMenu && (
        <div
          className="dashboard__block__group-by__drop-menu"
          onMouseEnter={enterDownMenu}
          onMouseLeave={leaveDownMenu}
        >
          <span className="dashboard__block__group-by__drop-menu__label">Group by</span>
          {options.map((item) => (
            <button
              key={item}
              className={`dashboard__block__group-by ${item}`}
              onClick={() => {
                setOpenDownMenu(false);
                setSelect(item);
              }}
            >
              <span>{item}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default GroupByBtn;
